// export default ActivityLogsPage;

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ActivityFiltersPanel from "../Components/ActivityLogs/ActivityFiltersPanel";
import useActivityLogsData from "../Hook/useActivityLogsData";
import Tablelist from "../Hook/list";
import { FaEye } from "react-icons/fa";
import Pagination from "../Hook/list/listfooter";
import { transformActivityData } from "../utils/transformActivityData";

const ActivityLogsPage = () => {
  const location = useLocation();

  const [filters, setFilters] = useState({
    search: "",
    dates: { date: ["", ""] },
    planname: {
      default: { label: "All" },
      list: [
        { label: "All" },
        { label: "Free" },
        { label: "Basic" },
        { label: "Pro" },
        { label: "Premium" },
        { label: "Uninstall" },
      ],
      triger: false,
    },
    currentPlan: {
      default: { label: "All" },
      list: [
        { label: "All" },
        { label: "Free" },
        { label: "Basic" },
        { label: "Pro" },
        { label: "Premium" },
        { label: "Uninstall" },
      ],
    },

  });

  const [pageNumber, setPageNumber] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState({
    defaultValue: 50,
    list: [50, 100, 250, 500],
  });

  const { activityLogs, loading, totalPages, totalRecords } =
    useActivityLogsData(filters, pageNumber, recordsPerPage.defaultValue);

  // Parse query parameters on initial load
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const plan = params.get("plan");
  const daterange = params.get("daterange");

  const matchedPlan = filters.planname.list.find(
    (item) => item.label.toLowerCase() === plan?.toLowerCase()
  );

  const dateRangeArray = daterange
    ? daterange.split(" ").filter(Boolean)
    : ["", ""];

  if (plan || daterange) {
    setFilters((prev) => ({
      ...prev,
      dates: { date: dateRangeArray.length === 2 ? dateRangeArray : ["", ""] },
      planname: {
        ...prev.planname,
        default: matchedPlan || { label: "All" },
        triger: true,
      },
    }));

    // Optional: auto-trigger filter
    handleGoClick("", dateRangeArray, matchedPlan?.label || "All");
  }
}, [location.search]);

  const handleGoClick = (searchVal, dateRange, selectedPlanname) => {
    setFilters((prev) => ({
      ...prev,
      search: searchVal,
      dates: { date: dateRange },
      planname: {
        ...prev.planname,
        default: { label: selectedPlanname || "All" },
      },
    }));
    setPageNumber(1);
  };


  const handleClearFilters = () => {
    setFilters((prev) => ({
      ...prev,
      search: "",
      dates: { date: ["", ""] },
      planname: {
        ...prev.planname,
        default: { label: "All" },
        triger: false,
      },
    }));
    setPageNumber(1);
  };

  const pageRange = Array.from({ length: totalPages }, (_, i) => i + 1);

  const [tableList, setTableList] = useState({
    thead: [
      { type: "text", title: "Date", key: "date" },
      {
        type: "link",
        title: "Store",
        element: { type: "view", key: "store_name", url: "store_url" },
      },
      { type: "text", title: "Activity", key: "action" },
      { type: "text", title: "Activity Label", key: "activityType" },
      { type: "text", title: "Current Plan Status", key: "currentPlanStatus" },
      { type: "text", title: "Current Shopify Plan", key: "shopifyPlan" },
      {
        type: "action",
        title: "Action",
        element: [
          {
            type: "view",
            icon: <FaEye color="#f5aa33" />,
            action: (e, id) => {
              e.preventDefault();
              const url = `/dashboard/reports/details?id=${id}`;
              window.open(url, "_blank");
            },
          },
        ],
      },
    ],
    tbody: [],
    tbodycopy: [],
  });

  useEffect(() => {
    const transformed = transformActivityData(activityLogs);
    setTableList((prev) => ({
      ...prev,
      tbody: transformed,
      tbodycopy: transformed,
    }));
  }, [activityLogs]);

  return (
    <div className="container px-5 py-5">
      <h2 className="text-warning mb-4">Activity Logs</h2>

      <div className="mb-3 border border-white p-3 bg-light rounded shadow-sm">
        <ActivityFiltersPanel
          filters={filters}
          setFilters={setFilters}
          onGoClick={handleGoClick}
          onClear={handleClearFilters}
        />
      </div>

      <div className="mb-3 grid-box">
        <Tablelist tabledata={tableList} loading={loading} />
      </div>

      <Pagination
        page={pageNumber}
        range={pageRange}
        slicedData={transformActivityData(activityLogs)}
        changePage={(e, newPage) => {
          e.preventDefault();
          setPageNumber(newPage);
        }}
        recordsPerPage={recordsPerPage}
        changeRecordsPerpage={(e, newCount) => {
          e.preventDefault();
          setRecordsPerPage((prev) => ({
            ...prev,
            defaultValue: newCount,
          }));
          setPageNumber(1);
        }}
        totalRecords={totalRecords}
      />
    </div>
  );
};

export default ActivityLogsPage;
